/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is gitignored and regenerated by
 * script/remote_lookup/update-ignored-files.ts via `yarn update-generated-files`.
 *
 * @owner @Appboy/messaging-experience
 *
 * Friendly aliases over the cross-type generated modules for the
 * "cohort" remote lookup provider. Items are server output (the Output
 * variants); ids and filters are client-constructed input (the unsuffixed
 * variants).
 */
import type { z } from "zod";

import type { RemoteLookupProvider } from "../providers/types";

import type { IdType } from "../../../../cross_type/braze/remote_lookup/providers/cohort_remote_lookup_provider/id_type.types";
import type { ItemTypeOutput } from "../../../../cross_type/braze/remote_lookup/providers/cohort_remote_lookup_provider/item_type.types";
import type { FiltersType } from "../../../../cross_type/braze/remote_lookup/providers/cohort_remote_lookup_provider/filters_type.types";

import { idTypeSchema } from "../../../../cross_type/braze/remote_lookup/providers/cohort_remote_lookup_provider/id_type.schemas";
import { itemTypeOutputSchema } from "../../../../cross_type/braze/remote_lookup/providers/cohort_remote_lookup_provider/item_type.schemas";
import { filtersTypeSchema } from "../../../../cross_type/braze/remote_lookup/providers/cohort_remote_lookup_provider/filters_type.schemas";

export type CohortRemoteLookupId = IdType;
export type CohortRemoteLookupItem = ItemTypeOutput;
export type CohortRemoteLookupFilters = FiltersType;

export type CohortRemoteLookupProvider = RemoteLookupProvider<
  CohortRemoteLookupId,
  CohortRemoteLookupItem,
  CohortRemoteLookupFilters
>;

// The casts absorb zod's invariance over nullable/optional object properties;
// the schemas and interfaces are generated from the same source schema, so the
// shapes are exact.
export const cohortRemoteLookupValidators = {
  id: idTypeSchema as z.ZodType<CohortRemoteLookupId>,
  item: itemTypeOutputSchema as z.ZodType<CohortRemoteLookupItem>,
  filters: filtersTypeSchema as z.ZodType<CohortRemoteLookupFilters>,
};
